<template>
  <div>
    <span class="button pdf" @click="generatePDF">Zusammenfassung als PDF</span>
  </div>
</template>
<script>

export default {
  name: "PDFGenerator",
  methods: {
    generatePDF() {
      const formData = new FormData();
      formData.append('mode', this.$parent.mode);
      formData.append('users', this.$parent.users.value);
      formData.append('mandates', this.$parent.mandates.value);

      for (const packageItem of Object.values(this.$parent.packages)) {
        const packageEnabled = packageItem.enabled;
        formData.append(packageItem.key, packageEnabled);

        for (const option of Object.values(packageItem.options)) {
          const optionEnabled = !packageEnabled ? false : option.enabled;
          formData.append(option.key, optionEnabled);
        }
      }
      fetch('/configurator-pdf.php', {
        method: 'post',
        body: formData
      })
          .then((response) => response.blob())
          .then(res => {
            const date = new Date();
            const dateFormatter = new Intl.DateTimeFormat('de-CH', {
              day: '2-digit',
              month: 'long',
              year: 'numeric',
            });
            const link = document.createElement("a");
            link.setAttribute("download", `Pinus21-Konfiguration vom ${dateFormatter.format(date)}.pdf`);
            const href = URL.createObjectURL(res);
            link.href = href;
            link.setAttribute("target", "_blank");
            link.click();
            URL.revokeObjectURL(href);
          })
          .catch()
    }
  }
}
</script>
